import {isDark} from '@cohort/shared-frontend/utils/isDark';
import type {BaseButtonProps} from '@cohort/wallet/components/button/BaseButton';
import {BaseButton} from '@cohort/wallet/components/button/BaseButton';
import {Colors} from '@cohort/wallet/lib/Theme';
import Color from 'color';
import React from 'react';

type CohortButtonProps = BaseButtonProps;

const CohortButton: React.FC<CohortButtonProps> = ({className, ...props}): JSX.Element => {
  const backgroundColor = props.style?.backgroundColor ?? Colors.Gray200;

  const style = {
    backgroundColor: backgroundColor,
    color: String(
      Color(isDark(backgroundColor) ? Colors.White : Colors.Black).alpha(props.disabled ? 0.5 : 1)
    ),
    outlineColor: backgroundColor,
  };

  return <BaseButton className={className} style={style} {...props} />;
};

export default CohortButton;
